<template>
    <rkm-layout-body title="Lista de óbito">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-obito-create' })"
                authorize="store-cadastro-obito"
                color="primary"
            >
                Cadastrar óbito
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/obito/List'

export default {
    components: {List},
}
</script>